import { City } from "./city";


export class  Company {

    refNo: number;
    companyName: string;
    parentCompanyCode: number;
    companyType: string;
    industrySegmentCode: number;
    industrySubSegmentName: string;
    businessType: string;
    cityCode: number;
    address: string;
    pin: string;
    mobileNo: string;
    email: string;
    web: string;
    gstNo: string;
    pan: string;
    noOfManufacturingUnits: string;
    noOfRetailsOutlets: string;
    numberOfEmployees: string;
    latitude: string;
    longitude: string;
    businessRegNo: string;
    companyImagePath: string;
    companyImagePathForEdit: string;
    city: City = new City;

    //For import
    parentCompanyName: string;
    industrySegmentName: string;
    cityName: string;
}
